import React from 'react';
import { FiInfo } from 'react-icons/fi';

import { Button, Card } from '@/components';
import { IconFigure } from '@/components/Icons';
import { useIsDesktop } from '@/hooks/useIsDesktop';

type Props = {
  onClickChangeToVip: () => void;
  onClickOpenVideoModal?: () => void;
};

export const CardChangeTdaVip: React.FC<Props> = (props) => {
  const { isMobile } = useIsDesktop();
  return (
    <Card className="flex justify-between px-2 lg:px-0 h-[72px] w-full py-0 items-center lg:items-start bg-white mt-2 lg:mt-8 font-medium text-sm">
      <figure className="w-8 mr-3 lg:w-7">
        <IconFigure />
      </figure>
      {isMobile ? (
        <div className="flex-1">
          Cambiar Torneo Común
          <br />a <strong className="text-gdt-blue">Torneo VIP</strong>
        </div>
      ) : (
        <div className="flex-1">
          Cambiar Torneo Común
          <br />a <strong className="text-gdt-blue">Torneo VIP</strong>
          <FiInfo
            className="inline-block text-gdt-blue relative lg:relative lg:right-auto left-[5px] lg:left-0 lg:top-0 -top-[3px] cursor-pointer hover:opacity-90 ml-[5px]"
            size={16}
            onClick={() => {
              props.onClickOpenVideoModal && props.onClickOpenVideoModal();
            }}
          />
        </div>
      )}
      <Button
        className="w-[70px] lg:w-[142px] h-9 lg:h-[42px] p-0 text-xs lg:text-sm"
        type="button"
        variant="secondary"
        onClick={() => props.onClickChangeToVip()}
      >
        Cambiar
      </Button>
    </Card>
  );
};
